import { Video } from "lucide-react";
import { useTranslation } from "react-i18next";

import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import i18n from "@/i18n";
import { VIPRO_ADVERTISEMENT_CTA_MESSAGE, VIPRO_PATH } from "@/utils/constants";
import { trackEvent } from "@/utils/tracking";

export const Header = () => {
  const { t } = useTranslation();

  return (
    <header className="bg-white p-3 shadow-sm">
      <div className="mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <a href="https://vipro.studio" className="text-blue-500 hover:text-blue-600">
            <img src="/logo.png" alt="Vipro.studio" className="h-10 w-10 rounded-full" />
          </a>
          <span className="flex-col-2 flex items-baseline gap-2">
            <h1 className="font-bold md:text-xl">
              <a href="https://vipro.studio" className="text-blue-500 hover:text-blue-600">
                Vipro.studio
              </a>{" "}
              {t("thumbnailReviewer.home.title")}
            </h1>
          </span>
        </div>
        <div className="flex items-center gap-3 text-xs">
          {/* Show these buttons only on desktop */}
          <div className="hidden items-center gap-3 sm:flex">
            <LanguageSwitcher />
            <span className="group flex">
              <a
                href={VIPRO_PATH}
                target="_blank"
                rel="noopener noreferrer"
                className="flex animate-[gradient_2s_linear_infinite] items-center gap-2 rounded-lg bg-gradient-to-r from-blue-600 via-purple-600 to-blue-600 bg-[length:200%_100%] px-4 py-3 text-sm font-medium text-white transition-all duration-200 hover:shadow-lg"
                onClick={() => trackEvent("thumbnail_reviewer_create_video_link_click")}
              >
                <Video className="h-4 w-4" />
                <span className="hidden sm:inline">
                  {
                    VIPRO_ADVERTISEMENT_CTA_MESSAGE[
                      i18n.language as keyof typeof VIPRO_ADVERTISEMENT_CTA_MESSAGE
                    ]
                  }
                </span>
              </a>
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};
